import { Container, Grid } from "@material-ui/core";
import React from "react";
import { ClearRefinements, CurrentRefinements, NumericMenu, RefinementList, Stats } from "react-instantsearch-dom";



export default function FilterBay() {
	// const TwoElementSlider = (props, {
	// 	currentRefinement,
	// 	min,
	// 	max,
	// 	refine,
	// 	type,
	// 	units,
	// 	// ...props
	// }) => {
	// 	const initialShares =
	// 		currentRefinement !== undefined
	// 			? [currentRefinement.min, currentRefinement.max]
	// 			: [];
	// 	let [shares, setShares] = useState(initialShares);

	// 	useEffect(() => {
	// 		if (
	// 			currentRefinement?.min!== undefined ||
	// 			currentRefinement?.max!== undefined
	// 		) {
	// 			setShares([currentRefinement.min, currentRefinement.max]);
	// 		} else {
	// 			setShares([0, 0]);
	// 		}
	// 	}, [currentRefinement]);

	// 	const handleShareChange = (event, newValue) => {
	// 		const [newMin, newMax] = newValue;

	// 		if (shares[0] !== newMin || shares[1] !== newMax) {
	// 			refine({
	// 				min: newMin,
	// 				max: newMax,
	// 			});
	// 		}
	// 		setShares(newValue);
	// 	};

	// 	return (
	// 		<div
	// 			style={{
	// 				display: "flex",
	// 				alignItems: "center",
	// 				justifyContent: "center",
	// 				flexFlow: "column-reverse wrap",
	// 			}}
	// 		>
	// 			<div
	// 				style={{
	// 					display: "flex",
	// 					alignItems: "center",
	// 					justifyContent: "center",
	// 					flexFlow: "row wrap",
	// 				}}
	// 			>
	// 				between
	// 				<h5 className="" style={{ padding: "0 1rem" }}>
	// 					{shares[0]} {units}
	// 				</h5>
	// 				and
	// 				<h5 style={{ padding: "0 1rem" }}>
	// 					{shares[1]} {units}
	// 				</h5>
	// 			</div>
	// 			<Slider
	// 				value={shares}
	// 				onChange={handleShareChange}
	// 				min={min}
	// 				max={max}
	// 				valueLabelDisplay="auto"
	// 				aria-labelledby="range-slider"
	// 			/>
	// 		</div>
	// 	);
	// };


	// 2. Connect the component using the connector
	// const CustomVidSlider = connectRange(TwoElementSlider);
	// const CustomShareSlider = connectRange(TwoElementSlider);
	// const CustomCommentSlider = connectRange(TwoElementSlider);
	// const CustomAdScoreSlider = connectRange(TwoElementSlider);
	// const CustomLikesSlider = connectRange(TwoElementSlider);

	return (
		<Container sm={12}>

			<Grid container spacing={5}>
				<Grid item sm={12}>
					<div style={{display:"flex", maxWidth:"80%", alignItems:"center", justifyContent:"center"}}>
						<h5>Current Refinements ➡️</h5>
						<CurrentRefinements clearsQuery label="Current Filters" />
					<ClearRefinements />
					</div>
				</Grid>
				<Grid item sm={4}>

					<h4>Categories 🌎</h4>
					<RefinementList 
					attribute={'Category'} 
					limit={2} 
					showMore 
					/>
				</Grid>

				<Grid item sm={4}>
					<h4>Classifications 🦄</h4>
					<RefinementList
						limit={2}
						attribute={`Classification`}
						showMore
					/>
				</Grid>

				<Grid item sm={4} >
					<h4>Ad Score 🔥</h4>
					<RefinementList
					attribute={`Ad Score`}
					limit={2} 
					showMore 
					 />
				</Grid>

				<Grid item sm={4}>
					<h4>Verified Facebook ✅</h4>
					<RefinementList 
					attribute={`Verified Facebook`} 
					limit={2}
					/>
				</Grid>

				<Grid item sm={4}>
					<h4>Verified Instagram ✅</h4>
					<RefinementList 
					limit={2} 
					attribute={`Verified Instagram`} />
				</Grid>
				

				<Grid item sm={4}>
					<h4>Video Length ⏱</h4>
					<NumericMenu
						attribute={`Video Duration`}
						limit={2}
						showMore
						items={[
						{ start: 0, end: 1, label: '0s - 5s' },
						{ start: 2, end: 3, label: '6s - 15s'},
						{ start: 4, end: 5, label: '16s - 30s' },
						{ start: 6, end: 7, label: '31s - 60s' },
						{ start: 8, end: 9, label: '61s - 120s' },
						{ start: 10, end: 11, label: '121s - 180s' },
						{ start: 12, end: 13, label: '180s+'}
					]}
					/>
				</Grid>
				
				{/* <Grid item sm={3}>
					<h4>Video Length ⏱</h4>

					<RangeMenuSelect

						type="video"
						units="seconds"
					attribute={`video_duration_secs`} />
				</Grid> */}

				<Grid item sm={4}>
					<h4>Likes 👍</h4>
					<NumericMenu
						attribute={`Likes`}
						limit={2}
						showMore
						items={[
						{ start: 0, end: 1, label: '0 - 25' },
						{ start: 2, end: 3, label: '25 - 100'},
						{ start: 4, end: 5, label: '101 - 250' },
						{ start: 6, end: 7, label: '251 - 500' },
						{ start: 8, end: 9, label: '501 - 1000'},
						{ start: 10, end: 11, label: '1001 - 5000'},
						{ start: 12, end: 13, label: '5001 - 20,000'},
						{ start: 14, end: 15, label: '20,001 - 50,000'},
						{ start: 16, end: 17, label: '50,000+'}
					]}
					/>
				
				</Grid>
				 {/* <Grid item sm={3}>
					<h4>Ad Score 🔥</h4>
					<CustomAdScoreSlider
						type="ads"
						units="/ 10"
						attribute={`ad_score`} />
				</Grid>  */}


				 {/* <Grid item sm={3} id="post-reactions">
					<h5>Likes</h5>
					<CustomLikesSlider
						type="likes"
						units="likes"

					attribute={"post_reactions"} />
				</Grid>   */}


				<Grid item sm={4} id="Comments">
					<h4>Comments 🗯</h4>
					
					<NumericMenu
						attribute={`Comments`}
						limit={2}
						showMore
						items={[
						{ start: 0, end: 1, label: '0 - 25' },
						{ start: 2, end: 3, label: '25 - 100'},
						{ start: 4, end: 5, label: '101 - 250' },
						{ start: 6, end: 7, label: '251 - 500' },
						{ start: 8, end: 9, label: '501 - 1000'},
						{ start: 10, end: 11, label: '1001 - 5000'},
						{ start: 12, end: 13, label: '5001 - 20,000'},
						{ start: 14, end: 15, label: '20,001 - 50,000'},
						{ start: 16, end: 17, label: '50,000+'}
					]}
					/>
				</Grid> 

				<Grid item sm={4} id="Shares">
					<h4>Shares 🤳</h4>
					
						<NumericMenu
						attribute={`Shares`}
						limit={2}
						showMore
						items={[
						{ start: 0, end: 1, label: '0 - 25' },
						{ start: 2, end: 3, label: '25 - 100'},
						{ start: 4, end: 5, label: '101 - 250' },
						{ start: 6, end: 7, label: '251 - 500' },
						{ start: 8, end: 9, label: '501 - 1000'},
						{ start: 10, end: 11, label: '1001 - 5000'},
						{ start: 12, end: 13, label: '5001 - 20,000'},
						{ start: 14, end: 15, label: '20,001 - 50,000'},
						{ start: 16, end: 17, label: '50,000+'}
					]}
					/> 
				</Grid>  
				
				<Grid item sm={12} id="stats" className="filter-stats-info">
					<Stats />
				</Grid>
			</Grid>

		</Container>
	);
}
